import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Paginator } from '../../../../tms-tools/helpers/paginator';
import { PageService } from 'app/modules/catalog-cloud/services/page.service';
import { User } from '@nousmedis/guard-types/frontend';
import { AuthModel } from '@nousmedis/nm-guard-auth';
import { Page } from '@nousmedis/cc-types';
import { FascicleService } from 'app/modules/catalog-cloud/services/fascicle.service';
import { Observable, Observer, Subscription } from 'rxjs';
import { GridLocked } from 'app/modules/catalog-cloud/interfaces/grid-locked.interface';

@Component({
  selector: 'app-fascicle-paginator',
  templateUrl: './fascicle-paginator.component.html',
  styleUrl: './fascicle-paginator.component.scss'
})
export class FasciclePaginatorComponent implements OnInit, OnDestroy {
  @Input() gPage: Paginator;
  @Input() currentNumberPages: any;
  @Input() pages: Page[] = [];
  @Input() currentComboPageIndex: number;

  @Output() onNavigate = new EventEmitter<{action: 'prev' | 'next' | 'first' | 'last' | 'index', index?: number}>();

  enablePaginationObserver: Subscription = new Subscription();
  enablePagination: boolean = true;

  user: User;
  pageAfter: number | null = null;
  pageBefore: number | null = null;

  constructor (private pageService: PageService, private auth: AuthModel, private fascicleService: FascicleService) {
    this.user = this.auth.getCurrentUser();
  }

  ngOnInit(): void {
    // Initialize component logic here
    this.startSubscriptions();
  }

  ngOnDestroy(): void {
    // Clean up subscriptions and other resources
    this.stopSubscriptions();
  }
  stopSubscriptions() {
    if (this.enablePaginationObserver) {
      this.enablePaginationObserver.unsubscribe();
    }
  }
  startSubscriptions() {
    this.enablePaginationObserver = this.fascicleService.lockButtons.subscribe((gridLocked:GridLocked) => {
      this.enablePagination = gridLocked.locked;
    });
  }

  changePageFromDropdown(pageIndex: any) {
    this.onNavigate.emit({ action: 'index', index: pageIndex.key });
  }

  addPage() {
    this.pageService.goToIndex = this.pages.length;
    this.pageService.addPage(this.user.id);
  }

  addPageFirst() {
    this.pageService.goToIndex = 0;
    this.pageService.addPageFirst(this.user.id);
  }

  addPageBefore(pageNumber: number) {
    //trigger.closeMenu();
    //this.selectPageBefore.value = null;
    this.pageService.goToIndex = this.pages
      .map((p) => {
        return p.pageNumber;
      })
      .indexOf(pageNumber);
    this.pageService.addPageBefore(this.user.id, pageNumber);
  }

  addPageAfter(pageNumber: number) {
    //trigger.closeMenu();
    //this.selectPageAfter.value = null;
    this.pageService.goToIndex =
      this.pages
        .map((p) => {
          return p.pageNumber;
        })
        .indexOf(pageNumber) + 1;

    this.pageService.addPageAfter(this.user.id, pageNumber);
  }

}
